import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerticalLineComponent } from './vertical-line.component';

@NgModule({
	declarations: [VerticalLineComponent],
	imports: [CommonModule],
	exports: [VerticalLineComponent],
})
export class VerticalLineModule {}
